import { action, runInAction, makeAutoObservable } from 'mobx';
import { State } from '~store/types';
import UserProfileEntry from '~store/Profile/UserProfileEntry';
import { Alert, Profile } from '@ixicare/resources';
import AlertStore from '~store/Alert/Alert';

class ResidentDetailStore {
  rootStore: State;
  profile: UserProfileEntry | null = null;
  error: Error | null = null;
  alerts: AlertStore[] = [];
  loading: boolean = true;

  constructor(rootStore: State) {
    makeAutoObservable(this, {
      loadResident: action.bound,
      loadAlerts: action.bound,
      clear: action.bound,
      rootStore: false,
    });
    this.rootStore = rootStore;
  }

  loadResident(id: string, profileLoaded?: (prof: UserProfileEntry) => void) {
    this.loading = true;
    Profile.getProfile(id)
      .then((profile) => {
        runInAction(() => {
          this.profile = new UserProfileEntry(this.rootStore, profile);
          if (profileLoaded) {
            profileLoaded(this.profile);
          }
          this.loading = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.loading = false;
          this.error = error;
        });
      });
  }

  loadAlerts() {
    if (!this.profile) return;
    Alert.getAlertsV2({
      limit: 10,
      resident_id: this.profile.uuid,
      // Without a site the API scopes the list to the viewer's own site, which
      // hides the resident's alarms whenever those differ.
      site_uuid: this.profile.site?.uuid,
    }).then((data) => {
      runInAction(() => {
        this.alerts = data.map((al) => new AlertStore(this.rootStore, undefined, al));
      });
    });
  }

  clear() {
    this.profile = null;
  }

  get alertsSorted() {
    return this.alerts.slice().sort((a, b) => b.created.getTime() - a.created.getTime());
  }

  get alertsInProgress() {
    return this.alertsSorted.filter((alarm) => !alarm.isResolved && !alarm.isCancelled);
  }

  get previousAlerts() {
    return this.alertsSorted.filter((alarm) => alarm.isResolved || alarm.isCancelled);
  }
}

export default ResidentDetailStore;
